import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex items-center justify-between"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_btn_group = _resolveComponent("q-btn-group")!

  return (_ctx.numPages)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("span", null, _toDisplayString(_ctx.statusText), 1),
        _createVNode(_component_q_btn_group, { rounded: "" }, {
          default: _withCtx(() => [
            _createVNode(_component_q_btn, {
              icon: "fa fa-angle-left",
              color: "white",
              "text-color": "primary",
              disable: _ctx.offset < _ctx.perPage,
              onClick: _ctx.prevPage
            }, null, 8, ["disable", "onClick"]),
            _createVNode(_component_q_btn, {
              icon: "fa fa-angle-right",
              color: "white",
              "text-color": "primary",
              disable: (_ctx.offset + _ctx.perPage) >= _ctx.total,
              onClick: _ctx.nextPage
            }, null, 8, ["disable", "onClick"])
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}